import NavigateBack from "../components/navigateBack";
import { useEffect, useState } from "react";
import createPersistedState from "use-persisted-state";
import { useHistory } from "react-router-dom";
import { translations } from "../locales/healthInfo";
import { useTranslation } from "react-i18next";

//TODO: To refactor
const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

function MyHealthInfoPage() {
  const [healthInfo, setHealthInfo] = useState(null);
  const [noHealthInfo, setNoHealthInfo] = useState(false);

  const [token, _] = useTokenState();
  const [pid, __] = usePIDState();
  const { t } = useTranslation();

  const history = useHistory();

  const questionSequence = [
    "Q1",
    "Q2",
    "Q3",
    "Q4",
    "Q5",
    "Q12",
    "Q6",
    "Q7",
    "Q8",
    "Q9",
    "Q10",
    "Q11",
    "Q12",
    "Q13",
    "Q14",
    "Q15",
    "Q16",
    "Q17",
    "Q18",
    "Q19",
    "Q20",
    "Q21",
    "Q22",
  ];

  const getUrl = () => `/api/v1/users/profile/${pid}/healthinfo`;

  useEffect(() => {
    fetchHealthInfo();
  }, [pid, token]);

  const fetchHealthInfo = () => {
    fetch(getUrl(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData["status"]["success"]) {
          if (responseData["healthInfo"]) {
            processResponse(responseData["healthInfo"]);
          } else {
            history.push("/health-info/start?from=/my-health");
          }
        }
      });
  };

  const processResponse = (info) => {
    let responses = {};
    //TODO: Better way to check if health info is submitted
    if (info[0]["response"] === null) {
      setNoHealthInfo(true);
      setHealthInfo(responses);
    } else {
      for (let i = 0; i < info.length; i++) {
        let r = info[i];
        const questionCode = r["code"];
        if (questionCode == "Q1") {
          r["response"] = r["response"] + " cm";
        }
        if (questionCode == "Q2") {
          r["response"] = r["response"] + " kg";
        }
        responses[questionCode] = {
          ...r,
        };
      }
      setHealthInfo(responses);
    }
  };

  const getTranslatedOption = (questionCode, choiceCode) => {
    if (
      translations["EN"][questionCode] &&
      translations["EN"][questionCode]["options"] &&
      translations["EN"][questionCode]["options"][choiceCode]
    ) {
      return t(questionCode + ".options." + choiceCode);
    } else {
      //console.log(questionCode);
      //console.log(choiceCode);
      //console.log((translations.metaData.yesCodesWR.indexOf(choiceCode) !== -1));
      if (translations.metaData.yesCodesWR.indexOf(choiceCode) !== -1) {
        return t("hi.yes");
      } else if (translations.metaData.yesCodes.indexOf(choiceCode) !== -1) {
        return undefined;
      } else if (translations.metaData.noCodes.indexOf(choiceCode) !== -1) {
        return t("hi.no");
      } else if (translations.metaData.otherCodes.indexOf(choiceCode) !== -1) {
        return undefined;
      } else if (translations.metaData.noneCodes.indexOf(choiceCode) !== -1) {
        return t("hi.nota");
      } else {
        return undefined;
      }
    }
  };

  const getProcessedOption = (q) => {
    if (q) {
      const qCode = q["code"]; //Question Code
      if (q["choices"]) {
        let responses = [];
        for (let i = 0; i < q["choices"].length; i++) {
          const choice = q["choices"][i];
          const choiceCode = choice["code"];
          if (choice["correct"]) {
            const translatedResponse = getTranslatedOption(qCode, choiceCode);
            if (translatedResponse !== undefined) {
              responses.push(translatedResponse);
            } else {
              responses.push(choice["text"]);
            }
          }
        }
        return responses.join(", ");
      } else {
        return q["response"]; //Do not translate, return the response as is
      }
    } else {
      return "";
    }
  };

  return (
    <>
      <NavigateBack title={t("hi.title")} />
      <div className="body_content">
        <div className="inner_body">
          <div className="orangeLink txt_color_primary">
            <a onClick={() => history.push("/health-info/start")}>
              {t("hi.updateInfo")}
            </a>
          </div>
          {healthInfo && !noHealthInfo ? (
            questionSequence.map((code, index) =>
              healthInfo.hasOwnProperty(code) ? (
                <div key={index}>
                  <span className="txt">{t(code + ".question")}</span>
                  <div className="subtle">
                    {getProcessedOption(healthInfo[code])}
                  </div>
                  <hr />
                </div>
              ) : (
                <></>
              )
            )
          ) : noHealthInfo ? (
            <>{t("hi.noInfo")}</>
          ) : (
            <>{t("hi.loadingInfo")}</>
          )}
        </div>
      </div>
    </>
  );
}

export default MyHealthInfoPage;
